import { find, register } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentPrefix
  const selectedLanguage = find(`.${componentPrefix}selected-language`, el)

  const closeOnOutsideClick = (event) => {
    const outsideClick = !el.contains(event.target)

    if (outsideClick) {
      closeLanguages()
    }
  }

  const openLanguages = () => {
    el.classList.toggle('open')
    document.addEventListener('scroll', closeLanguages)
    document.addEventListener('click', closeOnOutsideClick)
  }

  const closeLanguages = () => {
    el.classList.remove('open')
    document.removeEventListener('scroll', closeLanguages)
    document.removeEventListener('click', closeOnOutsideClick)
  }

  selectedLanguage.addEventListener('click', () => {
    openLanguages()
  })
}

register('LanguageSelect', component)
